import axios from "axios";

//import {grabVideos} from "../grabVideos.js";
import {buildVideoQuery} from "../buildVideoQuery.js";
import {grabVideos} from "../grabVideos.js";

export function getVideoListData(character,changeVideos,showVideos){
    
    showVideos(false);

    var videoQuery = buildVideoQuery(character);
    var videoData;

    axios.get(videoQuery)
    .then(function (response) {
        videoData = grabVideos(response);
        changeVideos(videoData);
        
        // console.log("IM THE Video DATA")
        // console.log(videoData)
    })
    .then(function(){
        showVideos(true);
    })

}


// WEBPACK FOOTER //
// ./src/components/includes/axios/getVideoListData.js